/**
 * Shared replayed-tool-output truncation for the executor provider adapters.
 *
 * The ReAct loop re-sends the whole conversation on every turn, so a single
 * large tool result (a `read_range` can be tens of KB of CSV/JSON) is paid for
 * again on every later turn. Both adapters shrink those older results the same
 * way because the unit is the same on both wires - one tool's output string.
 * Only the container differs: `function_call_output.output` on Responses, a
 * `tool_result` block's `content` on Messages.
 *
 * The recent-window budgets are NOT shared: they are counted in Responses items
 * on one wire and whole messages on the other.
 */

/** Per-tool-output budget before an older result is replayed as a preview. */
export const MAX_REPLAYED_TOOL_OUTPUT_CHARS = 2000;

/** Shrinks an old tool result to a head/tail preview before replaying it. */
export function truncateReplayedToolOutput(output: string): string {
  if (output.length <= MAX_REPLAYED_TOOL_OUTPUT_CHARS) return output;
  const head = output.slice(0, 1400);
  const tail = output.slice(-400);
  const elided = output.length - head.length - tail.length;
  return (
    `${head}\n…[${elided} chars elided to save context; the full result was ` +
    `returned to you in an earlier turn]…\n${tail}`
  );
}
